import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BrainCircuit, Blocks } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-24 relative overflow-hidden" data-id="element-86">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-600/10 rounded-full blur-[150px] pointer-events-none" data-id="element-87" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-88">
        <FadeIn data-id="element-89">
          <div className="text-center mb-16" data-id="element-90">
            <div className="inline-flex items-center justify-center p-4 bg-cyan-500/10 rounded-2xl mb-6 border border-cyan-500/20 shadow-[0_0_30px_rgba(6,182,212,0.2)]" data-id="element-91">
              <BrainCircuit className="w-12 h-12 text-cyan-400" data-id="element-92" />
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-93">
              El Protocolo Anti-Prompting:
              <br data-id="element-94" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500" data-id="element-95">
                Bloques de Contexto Estructurado
              </span>
            </h2>
          </div>
        </FadeIn>

        <div className="bg-[#111827]/80 backdrop-blur-sm border border-cyan-500/30 rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(6,182,212,0.1)]" data-id="element-96">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-97">
            <FadeIn delay={0.1} direction="left" data-id="element-98">
              <p className="text-xl text-[#d1d5db] leading-relaxed mb-6" data-id="element-99">
                En lugar de intentar adivinar qué decirle a la IA, este manual
                te entrega{' '}
                <span className="text-white font-bold" data-id="element-100">"piezas de Lego"</span>{' '}
                de texto.
              </p>
              <p className="text-lg text-slate-400 leading-relaxed" data-id="element-101">
                Solo tienes que copiar tu información, pegarla en nuestros
                marcos pre-estructurados y ver cómo el trabajo de 4 horas se
                resuelve en 4 minutos. No necesitas ser un experto en
                tecnología; solo necesitas saber copiar y pegar.
              </p>
            </FadeIn>

            <FadeIn delay={0.2} direction="right" className="relative" data-id="element-102">
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-2xl rounded-full" data-id="element-103" />
              <div className="relative bg-[#0a0f1a] border border-slate-700 rounded-xl p-6 space-y-4" data-id="element-104">
                <div className="flex items-center gap-3 text-cyan-400 border-b border-slate-800 pb-4" data-id="element-105">
                  <Blocks className="w-5 h-5" data-id="element-106" />
                  <span className="font-semibold text-sm uppercase tracking-wider" data-id="element-107">
                    Sistema Modular
                  </span>
                </div>
                <div className="space-y-3" data-id="element-108">
                  <div className="h-8 bg-slate-800/50 rounded border border-slate-700/50 flex items-center px-4 text-xs text-slate-400" data-id="element-109">
                    [Bloque de Contexto de Empresa]
                  </div>
                  <div className="h-8 bg-slate-800/50 rounded border border-slate-700/50 flex items-center px-4 text-xs text-slate-400" data-id="element-110">
                    + [Datos Crudos]
                  </div>
                  <div className="h-8 bg-cyan-900/30 rounded border border-cyan-500/30 flex items-center px-4 text-xs text-cyan-400" data-id="element-111">
                    = [Resultado Perfecto y Profesional]
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}